import React from 'react';
import classes from './FilterGroupsContainer.module.scss';
import { WithChildren } from '../../../models/children-props';
import classNames from 'classnames';
import { SquareButton } from 'components/actions/SquareButton';
import { SquareButtonIconsEnum } from 'constants/square-button-icons';

export type FilterGroupsContainerViewProps = WithChildren & {
  showClearButton: boolean;
  reset: CallableFunction;
  close: CallableFunction;
  isDropdown: boolean;
};

export const FilterGroupsContainerView = (props: FilterGroupsContainerViewProps): JSX.Element => {
  const { close, isDropdown, children } = props;

  // @TODO: this should be a helper function
  const isIOS = () => {
    return (
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    );
  };

  const filterGroupContainerClasses = classNames('margin-bottom-small-8', classes.FilterGroupsContainer, {
    [classes.FilterGroupsContainerIOSAdjustments]: isIOS()
  });

  return (
    <div className={filterGroupContainerClasses}>
      {isDropdown && (
        <div className={classNames('grid-x', classes.HeaderContainer)}>
          <h3 className={classes.TitleDrawer}>Filters</h3>
          <div className={classNames('cell shrink', classes.CloseButtonWrapper)}>
            <SquareButton
              type={'transparent'}
              icon={SquareButtonIconsEnum.close}
              action={() => {
                close(false);
              }}
            />
          </div>
        </div>
      )}
      {children}
    </div>
  );
};
